import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Paper,
} from "@material-ui/core/";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
//import DateRangeIcon from "@material-ui/icons/DateRange";
import { deepOrange } from "@material-ui/core/colors";
import { Chart as  GoogleChart } from "react-google-charts";
//import LocationOnIcon from "@material-ui/icons/LocationOn";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
//import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";

// import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import _ from "lodash";
import Chart  from "react-apexcharts";
import LocationOnIcon from "./../Assets/performance_map.png";
import DateRangeIcon from "./../Assets/performance_calendar.png";
import SummaryIcon from "./../Assets/audits.png"; 
import DeveloperBoardIcon from "./../Assets/performance_section.png";
import Colors from "./../../../Global/colors";
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop:'20px'
  },
  title: {
    fontSize: 17,
    fontWeight: "bold",
    alignSelf:'center',
    padding:5,
    marginTop:0,
    color:'#28272e'
  },
  title1: {
    marginLeft:10,
    marginTop:10,
    fontSize: 15,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
    "& li": {
      display: "inline",
      paddingLeft: 10,
      paddingRight: 10,
      color: "#4780b2",
    },
  },
  header: {
    padding: 0,
    paddingLeft: 5,
  },
  iconColor: {
    //color: deepOrange["300"],
    //fontSize: 15,
    //marginTop: 10,
    width: 21,
    height:30
  },
}));

export const PerformanceDash = ({
  performanceData_1,
  customGroupData,
  performanceDataPrevious,
  setModal
}) => {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  let [type, setType] = React.useState("Week");
  let [sections, setSections] = React.useState({});
  let [siteChart, setSiteChart] = React.useState([]);
  const [radialOption]=React.useState({
    plotOptions: {
      radialBar: {
        offsetY:-15,
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 10,
          size: "60%",
          background: Colors.globalColor8,
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 0,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "70%",
          margin: 4, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 4,
            opacity: 0.35
          }
        },

        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -2,
            show: true,
            color: "#FFF",
            fontSize: "10px"
          },
         
          value: {
            offsetY: 0,
            color: "#FFF",
            fontSize: "12px",
            show: true
          },
          
        }
      }
    },
    
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        colorStops: [
           {
                offset: 0,
                color: "#01defe",
                opacity: 1
              },
              {
                offset: 20,
                color: "#1459f3",
                opacity: 1
              },
        ]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [language == 'ar' ? "نقاط" : "Score"]
  })
  const [lineOptions,setLineOption]= React.useState({})
  const [lineSeries,setSeries]=React.useState([])

  const [groupedOptions,setGroupedOption]= React.useState({})
  const [groupedSeries,setGroupedSeries]=React.useState([])

  async function handleSections() {
    if (
      performanceData_1.section_data &&
      performanceDataPrevious.section_data
    ) {
      console.log(performanceData_1.section_data, "length");
      console.log(performanceDataPrevious.section_data, "length 2");

      let combined_data = [
        ...performanceData_1.section_data,
        ...performanceDataPrevious.section_data,
      ];

      let grouped_sections = await _.groupBy(combined_data, (v) => {
        // console.log(v)
        return v.title;
      });

      
      setSections(grouped_sections);
    }
  }

  async function handleSites() {
    console.log("+++++++++++++++++SITES++++++++++++++++");
    if (performanceData_1.site_arr && performanceDataPrevious.site_arr) {
      let combined_data = [
        ...performanceData_1.site_arr,
        ...performanceDataPrevious.site_arr,
      ];

      let grouped_sites = await _.groupBy(combined_data, (v) => {
        // console.log(v)
        return v.title;
      });

      let arr = [["Site", "Curent Score", "Previous Score"]];
      await Object.keys(grouped_sites).map(async (v) => {
        let score = 0;
        let score_1 = 0;
        let score_length = 0;
        let score_length_1 = 0;

        await grouped_sites[v].map((val) => {
          if (val.type == "current") {
            console.log(val.score, "op");
            score += val.score;
            score_length += 1;
          } else {
            score_1 += val.score;
            score_length_1 += 1;
          }
        });

        arr.push([
          v,
          parseInt(score / score_length)
            ? parseInt((score / score_length).toFixed())
            : 0,
          parseInt(score_1 / score_length_1)
            ? parseInt((score_1 / score_length_1).toFixed())
            : 0,
        ]);
      });
      console.log(arr);

      setSiteChart(arr);
      let sitecategory=[]
      let sitecurrent=[]
      let siteprevious=[]
      for(var i=1;i<arr.length;i++){
        sitecategory.push(arr[i][0])
        sitecurrent.push(arr[i][1])
        siteprevious.push(arr[i][2])
      }
      let groupOptions={
        chart: {
          type: 'bar',
          height: 430
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: sitecategory,
        },
        fill: {
          type: "gradient",
          //type: 'solid',
          opacity: 0.9,
          colors:["#153e6a","#1b8dcc"],
        },
        legend: {
          show: true,
          markers:{
            fillColors:["#153e6a","#1b8dcc"],
          }
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: true,
           },
           custom: function({series, seriesIndex, dataPointIndex, w}) {
            return '<div class="arrow_box">' +
              '<span> <b> Inspection Count: </b>' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>'
          }
        },
      }
      var groupDataSet=[
        {
        name:"Current",
        data:sitecurrent
        },
        {
         name:"Previous",
         data:siteprevious
        }
      ]
      setGroupedOption(groupOptions)
      setGroupedSeries(groupDataSet)
    }
  }

  React.useEffect(
    () => {
      handleSections();
      handleSites();

      let data=[]
      let category=[]
      
      for(var i=1;i<performanceData_1.chart_data.length;i++){
        data.push(performanceData_1.chart_data[i][1])
        category.push(performanceData_1.chart_data[i][0])
      }
      var dataSet=[{
        name:"Data",
        data:data
      }]
      
      let option={
        chart: {
         height: 380,
         type: "line",
         foreColor: '#6D6D6D',
       },
       markers: {
         size: 4,
         colors: ["#098af7"],
         strokeColors: "#fff",
         strokeWidth: 4,
         hover: {
           size: 7
         }
       },
       fill: {
         type: "gradient",
         gradient: {
           shadeIntensity: 1,
           opacityFrom: 0.7,
           opacityTo: 0.9,
           colorStops: [
            {
              offset: 0,
              color: "#01defe",
              opacity: 1
            },
            {
              offset: 20,
              color: "#1459f3",
              opacity: 1
            },
           ]
         }
       },
       grid: {
          borderColor: '#6D6D6D',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
       },
       xaxis: {
         categories:category,
         labels: {
          show: false
        },
        
       },
       
       tooltip: {
         enabled: true,
         fillSeriesColor: false,
         marker: {
           show: true,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
           return '<div class="arrow_box">' +
             '<span> <b> Inspection Count: </b>' + series[seriesIndex][dataPointIndex] + '</span>' +
             '</div>'
         }
       },
       
      }
     
   
      setLineOption(option)
      setSeries(dataSet)
      
      //alert(sitecurrent)
    },
    [performanceDataPrevious, performanceData_1],
  );

  
  return <div className={classes.root}>
      <Grid container direction="row" spacing={2} justify="flex-start" alignItems="flex-start">
        <Grid item xs={12} sm={12} lg={7}>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Card variant="outlined" style={{position:'relative',minHeight: 130, padding: 10, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
              <Tooltip title={t("Represents the comparative performance of inspections conducted in their respective time and score percentage completed.")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:language !== 'ar' && 10 , left:language == 'ar' && 10  , top:10}} />
                    </Tooltip>
                <Grid container spacing={2}>
                 {window.innerWidth > 500 && <Grid item xs={2} sm={3} md={2}>
                    <CardHeader classes={{ root: classes.header }} title={<div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-start", alignItems: "center" }}>
                          <img src={SummaryIcon} style={{ width: 33, height: 42,marginRight:language=="ar" && 10 }} />
                          <p className="filterHeading" style={{ color: Colors.globalColor8, justifyContent: "left", display: "flex", fontSize: 16, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                            {t("Overall")}
                          </p>
                        
                        </div>} />
                  </Grid>}
                  <Grid item xs={6} sm={4} md={4}>
                    <div style={{ marginLeft: 10, backgroundColor: "#FFF", //paddingLeft: 10,
                        borderRadius: 10, //width:200,
                        boxShadow: "1px 1px 3px 1px #FFF", justifyContent: "center" }}>
                      <div style={{ textAlign: "center", fontWeight: "bold", color: "#043077", fontSize: 18, alignSelf: "center", fontWeight: "bold" }}>
                        <p className="filterHeading" style={{ color: Colors.globalColor8, justifyContent: "center", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                          {t("Current")}
                        </p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Chart options={radialOption} series={[parseInt(performanceData_1.score) ? performanceData_1.score : 0]} type="radialBar" width="180" />
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignSelf: "center", marginTop: -20 }}>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: Colors.globalColor8,
                            fontSize: 15,
                            alignSelf: "center",
                          }}
                        >
                          {t("Inspection (Count)")}:
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: Colors.globalColor8,
                            fontSize: 18,
                            alignSelf: "center",
                            fontWeight: "bold",
                            marginLeft: 5,
                          }}
                        >
                          {parseInt(performanceData_1.total_inspections)
                            ? performanceData_1.total_inspections
                            : 0}
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={6} sm={4} md={4}>
                    <div style={{ marginLeft: 10, backgroundColor: "#FFF", //paddingLeft: 10,
                        borderRadius: 10, //width:200,
                        boxShadow: "1px 1px 3px 1px #FFF", justifyContent: "center" }}>
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <p className="filterHeading" style={{ color: Colors.globalColor8, justifyContent: "center", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                          {t("Previous")}
                        </p>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Chart options={radialOption} series={[parseInt(performanceDataPrevious.score) ? performanceDataPrevious.score : 0]} type="radialBar" width="180" />
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignSelf: "center", marginTop: -20 }}>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: Colors.globalColor8,
                            fontSize: 15,
                            alignSelf: "center",
                          }}
                        >
                          {t("Inspection (Count)")}:
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: Colors.globalColor8,
                            fontSize: 18,
                            alignSelf: "center",
                            fontWeight: "bold",
                            marginLeft: 5,
                          }}
                        >
                          {parseInt(performanceDataPrevious.total_inspections)
                            ? performanceDataPrevious.total_inspections
                            : 0}
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              {<Card variant="outlined" style={{position:'relative', minHeight: window.innerHeight * 0.455, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
              <Tooltip title={t("Represents the inspection performance based on sites via completion scores.")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:language !== 'ar' && 10 , left:language == 'ar' && 10 , top:10}} />
                    </Tooltip>
                  <CardHeader classes={{ root: classes.header }} title={<div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 10, marginLeft: 10 }}>
                        <img src={LocationOnIcon} className={classes.iconColor}  style={{marginRight:language=="ar" && 10 }}/>
                        <p className="filterHeading" style={{marginLeft:'10px', color: Colors.globalColor8, justifyContent: "left", display: "flex", fontSize: 16, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                          {t("By Sites")}
                        </p>
                      </div>} />
                  <CardContent>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Chart options={groupedOptions} series={groupedSeries} type="bar" />
                    
                    </div>
                    {/* {siteChart.length !== 0 && <GoogleChart
                    width={"500px"}
                    height={"180px"}
                    chartType="Bar"
                    loader={<div>Loading Chart</div>}
                    data={siteChart}
                    options={{
                      // legend: { position: 'none' }
                      colors: ["#25c2ed", "#ffb436"],
                    }}
                  />} */}
                  </CardContent>
                </Card>}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              {/* {performanceData_1.chart_data.length !== 0 && ( */}
              <Card variant="outlined" style={{position:'relative', minHeight: window.innerHeight * 0.455, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
              <Tooltip title={t("Represents inspections completed overtime in a weekly, monthly, quarterly and yearly format with a line graph for performance review")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:language !== 'ar' && 10 , left:language == 'ar' && 10  , top:10}} />
                    </Tooltip>
                <CardHeader classes={{ root: classes.header }} title={<div className={classes.title1}>
                      <div style={{ display: "flex", flexDirection: "row",alignItems:'center' }}>
                        <img src={DateRangeIcon} style={{ width: 24, height: 25,marginRight:language=="ar" && 10  }} />
                        <p className="filterHeading" style={{marginLeft:'10px', color: Colors.globalColor8, justifyContent: "left", display: "flex", fontSize: 16, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                          {/* By {type} */}
                          {t("By Week")}
                        </p>
                      </div>
                    </div>} />
                <CardContent>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Chart options={lineOptions} series={lineSeries} type="line" />
              
                  </div>
                </CardContent>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: -25 }}>
                  <li style={{ listStyleType: "none", marginRight: 10, color: Colors.buttonTextColor, fontWeight: "bold" }} className="cursor" onClick={() => {
                      setType("Week");
                      customGroupData("Week");
                    }}>
                    {t("WEEK")}
                  </li>
                  <li style={{ listStyleType: "none", marginRight: 10, color: Colors.buttonTextColor, fontWeight: "bold" }} className="cursor" onClick={() => {
                      setType("Month");
                      customGroupData("Month");
                    }}>
                    {t("MONTH")}
                  </li>
                  <li style={{ listStyleType: "none", marginRight: 10, color: Colors.buttonTextColor, fontWeight: "bold" }} className="cursor" onClick={() => {
                      setType("Quater");
                      customGroupData("Quater");
                    }}>
                    {t("QUARTER")}
                  </li>
                  <li style={{ listStyleType: "none", marginRight: 10, color: Colors.buttonTextColor, fontWeight: "bold" }} className="cursor" onClick={() => {
                      setType("Year");
                      customGroupData("Year");
                    }}>
                    {t("YEAR")}
                  </li>
                </div>
              </Card>
              {/* )}{" "} */}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12}  lg={5}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Card className="sectionCard" style={{position:'relative', backgroundColor: "white", borderRadius: "10px" }}>
                {/* {sections.length>0 && ( */}
                {/* <hr style={{backgroundColor: 'gray',height: 1,opacity:0.5,marginTop:20}}/> */}
                <Tooltip title={t("Represents a detailed review of performance with section based comparison identifying weak areas of inspections, where an orange circle means changes and a green arrow shows improvement")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:language !== 'ar' && 10 , left:language == 'ar' && 10  , top:10}} />
                    </Tooltip>
                <CardHeader classes={{ root: classes.header }} title={<div style={{ display: "flex", flexDirection: "row", alignItems: "center", alignSelf: "flex-start", marginTop: 10, marginLeft: 10 }}>
                      <img src={DeveloperBoardIcon} style={{ width: 32, height: 32,marginRight:language=="ar" && 10  }} />
                      <p className="filterHeading" style={{marginLeft:'10px', color: "#306086", justifyContent: "left", display: "flex", fontSize: 16, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                        {t("By Section")}
                      </p>
                    </div>} />
                {/* )}{" "} */}
                <CardContent>
                  <Grid container direction="row" justify="center" spacing={4}>
                    <Grid item xs={12} sm={12} md={12} style={{ paddingLeft: 20, paddingBottom: 0, overflowY: "auto", height: window.innerHeight * 0.66 }}>
                      <Grid container>
                        {Object.keys(sections)?.map((v, i) => {
                          var isOdd = i % 2;
                          let score_neg = [];
                          let score = 0;
                          let score_neg_1 = [];
                          let score_1 = 0;

                          let temp_arr_1 = [];
                          let temp_arr = [];
                          performanceData_1.grouped_sections && performanceData_1.grouped_sections[v] && performanceData_1.grouped_sections[v].map(
                              (val, valI) => {
                                if (val.type === "current") {
                                  val.CheckListInspections.filter(
                                    (che) => che.parent_id == null
                                  ).map((che) => {
                                    temp_arr.push(1);
                                    if (
                                      performanceData_1.answers_obj[che.id] ==
                                        null ||
                                      performanceData_1.answers_obj[che.id] ==
                                        "" ||
                                      performanceData_1.answers_obj[che.id] ==
                                        "[]" ||
                                      performanceData_1.answers_obj[che.id]
                                        ?.length === 0
                                    ) {
                                      // console.log(
                                      //   performanceData_1.answers_obj, performanceData_1.answers_obj[che.id], v
                                      // );
                                      score_neg.push(1);
                                    }
                                  });
                                  if (
                                    valI ===
                                    performanceData_1.grouped_sections[v]
                                      .length -
                                      1
                                  ) {
                                    // console.log(temp_arr.length);
                                    // score = performanceData_1.grouped_sections[v].length;
                                    score = (
                                      ((temp_arr.length - score_neg.length) /
                                        temp_arr.length) *
                                      100
                                    ).toFixed();
                                  }
                                }
                              }
                            );

                          performanceDataPrevious.grouped_sections && performanceDataPrevious.grouped_sections[v] && performanceDataPrevious.grouped_sections[v].map(
                              (val, valI) => {
                                if (val.type === "previous") {
                                  val.CheckListInspections.filter(
                                    (che) => che.parent_id == null
                                  ).map((che) => {
                                    temp_arr_1.push(1);
                                    if (
                                      performanceDataPrevious.answers_obj[
                                        che.id
                                      ] == null ||
                                      performanceDataPrevious.answers_obj[
                                        che.id
                                      ] == "" ||
                                      performanceDataPrevious.answers_obj[
                                        che.id
                                      ] == "[]" ||
                                      performanceDataPrevious.answers_obj[
                                        che.id
                                      ]?.length === 0
                                    ) {
                                      // console.log(
                                      //   performanceDataPrevious.answers_obj, performanceDataPrevious.answers_obj[che.id], v
                                      // );
                                      score_neg_1.push(1);
                                    }
                                  });
                                  if (
                                    valI ===
                                    performanceDataPrevious.grouped_sections[
                                      v
                                    ].length -
                                      1
                                  ) {
                                    // console.log(temp_arr_1.length);
                                    // score = performanceData_1.grouped_sections[v].length;
                                    score_1 = (
                                      ((temp_arr_1.length -
                                        score_neg_1.length) /
                                        temp_arr_1.length) *
                                      100
                                    ).toFixed();
                                  }
                                }
                              }
                            );
                          console.log(parseInt(score) == parseInt(score_1), parseInt(score) > parseInt(score_1), parseInt(score) < parseInt(score_1), score, parseInt(score_1));
                          return <Grid item xs={12} style={{ border: "1px solid #ebebeb", backgroundColor: isOdd == 1 ? "#fbfbfb" : "#FFF" }}>
                              <Grid container alignItems="center">
                                <Grid item xs={10}>
                                  <div
                                    style={{
                                      fontWeight: "bold",
                                      paddingLeft: 10,
                                      paddingTop: 10,
                                      color: "#28272e",
                                    }}
                                  >
                                    {v}
                                  </div>
                                  <div style={{ display: "flex" }
                                      //justifyContent: "space-between",
                                      //paddingBottom: 17,
                                    } key={i}>
                                    <span
                                      style={{
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        color: "#043077",
                                      }}
                                    >
                                      Previous:{" "}
                                      {parseInt(score_1) ? score_1 : 0}
                                    </span>
                                    <span style={{ color: "#043077" }}>
                                      Current: {parseInt(score) ? score : 0}{" "}
                                    </span>
                                  </div>
                                </Grid>
                                <Grid item align="center">
                                  {parseInt(score) === parseInt(score_1) && <Brightness1Icon style={{ color: "#ff9539" }} />}
                                  {parseInt(score) > parseInt(score_1) && <ArrowUpwardIcon style={{ color: "#06a05d" }} />}
                                  {parseInt(score) < parseInt(score_1) && <ArrowDownwardIcon style={{ color: "red" }} />}
                                </Grid>
                              </Grid>
                            </Grid>;
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>;
};
